<template>
  <vue-drawer-layout
      ref="drawer"
      :drawer-width="300"
      :enable="false"
      @mask-click="handleMaskClick"
      @slide-end="onDrawerSlideEnd">

    <div slot="drawer">
      <NavigationDrawer :close="closeDrawer" class="navigation-drawer"/>
    </div>

    <div slot="content" class="root-pane">
      <div><InternetOnOff/></div>
      <NavigationBar :toggle="openDrawer" class="nav"/>
      <div class="navigation-route-view">
        <router-view/>
      </div>
    </div>
  </vue-drawer-layout>
</template>

<script>
import NavigationBar from "@/components/layout/navigation/NavigationBar";
import NavigationDrawer from "@/components/layout/navigation/NavigationDrawer";
import InternetOnOff from "@/components/layout/NetworkChecker";
import Update from "@/components/layout/Update.vue";

export default {
  name: "Layout",
  computed: {
    getSaleUnits() {
      return this.$store.getters.getSaleUnits
    },
  },
  components: {NavigationDrawer, NavigationBar, InternetOnOff,Update},
  data(){
    return {
      showAlert: true,
      isDrawerOpen: false,
    }
  },
  methods: {
    /**
     * Opens the nav drawer when units are loaded and drawer ref exists.
     * Sentry RESTAURANT-POS-5/B/J: guard missing $refs.drawer.toggle.
     * Keep getSaleUnits gate so drawer stays closed until sale units ready.
     */
    openDrawer() {
      if (!this.getSaleUnits) {
        const drawer = this.$refs.drawer;
        if (drawer && typeof drawer.toggle === 'function') {
          drawer.toggle();
        }
        this.isDrawerOpen = true;
      }
    },
    /**
     * Closes the nav drawer when the ref is mounted.
     * Sentry RESTAURANT-POS-5/B/J: avoid TypeError during route changes.
     */
    closeDrawer() {
      const drawer = this.$refs.drawer;
      if (drawer && typeof drawer.toggle === 'function') {
        drawer.toggle(false);
      }
      this.isDrawerOpen = false;
    },
    handleMaskClick() {
      this.closeDrawer();
    },
    onDrawerSlideEnd(visible) {
      this.isDrawerOpen = visible;
    },
    handleDocumentClick(event) {
      if (!this.isDrawerOpen) return;
      const drawerRoot = this.$refs.drawer?.$el;
      if (!drawerRoot) return;
      const drawerWrap = drawerRoot.querySelector('.drawer-wrap');
      if (drawerWrap && drawerWrap.contains(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      this.closeDrawer();
    },
  },
  mounted() {
    // Add direct click handler to the drawer mask
    this.$nextTick(() => {
      const drawerElement = this.$refs.drawer?.$el;
      if (drawerElement) {
        const mask = drawerElement.querySelector('.drawer-mask');
        if (mask) {
          mask.addEventListener('click', this.closeDrawer);
        }
      }
    });
    if (typeof document !== 'undefined') {
      document.addEventListener('click', this.handleDocumentClick, true);
    }
  },
  beforeDestroy() {
    // Remove mask click handler
    const drawerElement = this.$refs.drawer?.$el;
    if (drawerElement) {
      const mask = drawerElement.querySelector('.drawer-mask');
      if (mask) {
        mask.removeEventListener('click', this.closeDrawer);
      }
    }
    if (typeof document !== 'undefined') {
      document.removeEventListener('click', this.handleDocumentClick, true);
    }
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  display: flex;
  justify-content: center; /* Center contents horizontally */
  margin-bottom: 10px; /* Adjust as needed */
}

.red-background-blink {
  background-color: #ffc400;
  animation: blink 1s infinite;
  padding: 10px 20px; /* Adjust height and width */
  //border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.root-pane {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.navigation-drawer {
  min-width: 285px;
  width: 100%;
  height: 100vh;
}

.navigation-route-view {
  transition: 0.5s ease;
  //padding-bottom: 40px !important;
}

.offline-banner {
  position: sticky;
  top: 0;
  left: 0;
  padding: 5px;
  display: block;
  text-align: center;
  width: 100%;
  background: rgb(220, 53, 69);
  color: white;
  right: 0;
}

// Fix for Drawer Z-Index
// Removed broken overrides
</style>
